import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, DownloadIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function PricingTable() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handlePurchase = () => {
    window.location.href = 'https://www.sinergianatural.com/cart/50923164827954:1';
  };
  return <section id="pricing-section" ref={ref} className="py-10 md:py-16 px-4 bg-gradient-to-b from-cream to-white scroll-mt-20" data-id="element-194">
      <div className="max-w-4xl mx-auto" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-196">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-warm-brown mb-8 md:mb-12 text-center px-2" data-id="element-197">
            Tu Inversión Hoy
          </h2>

          <div className="bg-white rounded-lg shadow-2xl p-6 md:p-12 border-2 border-sage mb-6 md:mb-8" data-id="element-198">
            <div className="overflow-x-auto mb-6 md:mb-8" data-id="element-199">
              <table className="w-full" data-id="element-200">
                <thead data-id="element-201">
                  <tr className="border-b-2 border-sage-light" data-id="element-202">
                    <th className="text-left py-3 md:py-4 px-2 md:px-4 font-heading text-base md:text-lg lg:text-xl text-gray-900" data-id="element-203">
                      Lo que recibes
                    </th>
                    <th className="text-right py-3 md:py-4 px-2 md:px-4 font-heading text-base md:text-lg lg:text-xl text-gray-900" data-id="element-204">
                      Valor Real
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 text-sm md:text-base" data-id="element-205">
                  <tr className="border-b border-gray-200" data-id="element-206">
                    <td className="py-3 md:py-4 px-2 md:px-4" data-id="element-207">
                      📗 Sinergia Ancestral — Ebook Completo (20 páginas)
                    </td>
                    <td className="text-right py-3 md:py-4 px-2 md:px-4 font-semibold" data-id="element-208">
                      $47
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-209">
                    <td className="py-3 md:py-4 px-2 md:px-4" data-id="element-210">
                      🔬 6 Protocolos Completos por Área de Salud
                    </td>
                    <td className="text-right py-3 md:py-4 px-2 md:px-4 text-sage-dark font-semibold" data-id="element-211">
                      Incluido
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-212">
                    <td className="py-3 md:py-4 px-2 md:px-4" data-id="element-213">
                      🧪 Guía Técnica de Preparación Maestra
                    </td>
                    <td className="text-right py-3 md:py-4 px-2 md:px-4 text-sage-dark font-semibold" data-id="element-214">
                      Incluido
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200" data-id="element-215">
                    <td className="py-3 md:py-4 px-2 md:px-4" data-id="element-216">
                      📅 Calendario de Transformación de 30 Días
                    </td>
                    <td className="text-right py-3 md:py-4 px-2 md:px-4 text-sage-dark font-semibold" data-id="element-217">
                      Incluido
                    </td>
                  </tr>
                  <tr className="border-b-2 border-sage-light" data-id="element-218">
                    <td className="py-3 md:py-4 px-2 md:px-4 font-bold text-gray-900 text-sm md:text-base" data-id="element-219">
                      VALOR TOTAL
                    </td>
                    <td className="text-right py-3 md:py-4 px-2 md:px-4 font-bold text-gray-900 text-lg md:text-xl" data-id="element-220">
                      $47
                    </td>
                  </tr>
                  <tr data-id="element-221">
                    <td className="py-4 md:py-6 px-2 md:px-4 font-heading text-lg md:text-xl lg:text-2xl text-terracotta" data-id="element-222">
                      🔥 TU PRECIO DE LANZAMIENTO HOY
                    </td>
                    <td className="text-right py-4 md:py-6 px-2 md:px-4" data-id="element-223">
                      <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-terracotta" data-id="element-224">
                        $6.39
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={handlePurchase} className="w-full bg-terracotta hover:bg-terracotta-dark text-white font-bold text-lg md:text-xl lg:text-2xl py-5 md:py-6 px-6 md:px-8 rounded-lg shadow-lg transition-all duration-200 mb-4 md:mb-6 cursor-pointer" aria-label="Descargar Sinergia Ancestral por $6.39" data-id="element-225">
              ✅ SÍ — QUIERO MI GUÍA POR SOLO $6.39
              <div className="text-sm md:text-base font-normal mt-2" data-id="element-226">
                DESCARGAR SINERGIA ANCESTRAL AHORA →
              </div>
            </motion.button>

            <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4 text-xs md:text-sm text-gray-600 mb-3 md:mb-4" data-id="element-227">
              <span className="flex items-center gap-2" data-id="element-228">
                <DownloadIcon className="w-3 h-3 md:w-4 md:h-4" aria-hidden="true" data-id="element-229" />
                Descarga inmediata
              </span>
              <span className="hidden md:inline" data-id="element-230">•</span>
              <span className="flex items-center gap-2" data-id="element-231">
                <CheckIcon className="w-3 h-3 md:w-4 md:h-4" aria-hidden="true" data-id="element-232" />
                Acceso de por vida
              </span>
              <span className="hidden md:inline" data-id="element-233">•</span>
              <span className="flex items-center gap-2" data-id="element-234">
                <ShieldCheckIcon className="w-3 h-3 md:w-4 md:h-4" aria-hidden="true" data-id="element-235" />
                Garantía de 60 días
              </span>
            </div>

            <p className="text-center text-gray-600 text-xs md:text-sm" data-id="element-236">
              Pago 100% seguro • Precio de lanzamiento exclusivo
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-terracotta-light/20 border-l-4 border-terracotta p-4 md:p-6 rounded-lg" data-id="element-237">
            <div className="flex items-start gap-2 md:gap-3" data-id="element-238">
              <ClockIcon className="w-5 h-5 md:w-6 md:h-6 text-terracotta flex-shrink-0 mt-1" aria-hidden="true" data-id="element-239" />
              <div className="text-sm md:text-base" data-id="element-240">
                <p className="font-semibold text-gray-900 mb-2" data-id="element-241">
                  💰 $6.39 es el precio de lanzamiento.
                </p>
                <p className="text-gray-700 mb-2" data-id="element-242">
                  Una vez que termine esta etapa inicial, el precio subirá
                  permanentemente.
                </p>
                <p className="text-gray-700 mb-2" data-id="element-243">
                  ⏰ No hay fecha de regreso a este precio. Cuando suba, sube
                  para siempre.
                </p>
                <p className="text-gray-700" data-id="element-244">
                  📲 La descarga es inmediata. En 2 minutos tienes el libro en
                  tus manos.
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}